<template>
  <div class="page_design_content">
    <div class="my_page_title" :style="`flex: 0 0 ${titleWidth}px`">{{title}}</div>
    <div class="page_design_radio">
      <el-radio-group v-model="select_value">
         <el-radio :label="1">{{$t('components_page_design_index_2453')}}</el-radio>
          <el-popover
          placement="top"
          width="270"
          trigger="hover"
          :content="tips('standard_design')"
          transition="zoom"
        >
          <i class="icon_tips mr-16" slot="reference">?</i>
        </el-popover>
      <el-radio :label="2">{{$t('components_page_design_index_2454')}}</el-radio>
        <el-popover
          placement="top"
          width="270"
          trigger="hover"
          :content="tips('differentiated_design')"
          transition="zoom"
        >
          <i class="icon_tips mr-16" slot="reference">?</i>
        </el-popover>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'page_design',
  props: {
    selectValue: {
      default: 1
    },
    titleWidth: {
      default: 78
    },
    title: {
      default: i18n.t('components_page_design_index_2455')
    },
    type: {
      default: 'list'
    }
  },
  data() {
    return {
      select_value: this.selectValue
    }
  },
  mounted() {
  },
  watch: {
    select_value(val, oldVal) { // 数据双向绑定
      this.$emit('update:selectValue', val);
      this.templet.p_init({
        designType: val
      });
    },
    'selectValue'(val) { // 数据双向绑定
      this.select_value = val
    }
  },
  computed: {
  },
  methods: {
    tips(designType) {
      const routeObj = {
        'product_index' : i18n.t('widgets_basic_classification_edit_482'),
        'product' : i18n.t('widgets_basic_classification_edit_482'),
        'case_index' : i18n.t('widgets_basic_article_classification_edit_334'),
        'case' : i18n.t('widgets_basic_article_classification_edit_334'),
        'article_index' : i18n.t('widgets_basic_article_classification_edit_333'),
        'article' : i18n.t('widgets_basic_article_classification_edit_333'),
        'video_index': i18n.t('view_download_index_181'),
        'video': i18n.t('view_download_index_181'),
        'help_index': i18n.t('widgets_basic_article_classification_edit_335'),
        'help': i18n.t('widgets_basic_article_classification_edit_335'),
        'download_index': i18n.t('router_index_69')
      }
      const productName = routeObj[this.$route.name] ? routeObj[this.$route.name] : i18n.t('widgets_basic_classification_edit_482')
      const obj = {
        'list': {
          'standard_design': i18n.t('components_page_design_index_2456', [productName]),
          'differentiated_design':  i18n.t('components_page_design_index_2457', [productName])
        },
        'detail': {
          'standard_design':  i18n.t('components_page_design_index_2458', [productName]),
          'differentiated_design':  i18n.t('components_page_design_index_2459', [productName])
        }
      }
      return obj[this.type][designType]
    }
  }
}
</script>

<style scoped lang="scss">
  .page_design_content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    .page_design_radio {
      margin-left: 8px;
      /deep/ .el-radio {
        margin-right: 6px;
      }
      .icon_tips {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        color: #d8d8d8;
        border: 1px solid #d8d8d8;
        border-radius: 50%;
        font-size: 13px;
        cursor: pointer;
      }
    }
  }
  .mr-16 {
    margin-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page_design/index.vue